import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { basePath } from '@atmi/core/injection';
import { Info, InfoState, ResponseSuccess, SystemInfo } from '@atmi/core/models';

const initialInfoState: InfoState = {
  info: undefined,
  systemInfo: undefined,
};

const INFO_KEY = 'atmi-info';

@Injectable()
export class InfoApiService {
  private readonly infoPath = `${this.baseUrl}/info`;
  private readonly systemInfoPath = `${this.baseUrl}/system-info`;

  private readonly state$ = new BehaviorSubject<InfoState>(initialInfoState);

  constructor(
    @Inject(basePath) private readonly baseUrl: string,
    private readonly http: HttpClient,
  ) {
    const stateFromStorage = localStorage.getItem(INFO_KEY);

    if (stateFromStorage) {
      const state: InfoState = JSON.parse(stateFromStorage);
      this.setState(state);
    }
  }

  info() {
    return this.http.get<ResponseSuccess<Info>>(this.infoPath).pipe(
      map((res) => res.data),
      tap((info) => {
        this.setState({ info });
      }),
      first(),
    );
  }

  systemInfo() {
    return this.http.get<ResponseSuccess<SystemInfo>>(this.systemInfoPath).pipe(
      map((res) => res.data),
      tap((systemInfo) => {
        this.setState({ systemInfo });
      }),
      first(),
    );
  }

  selectState() {
    return this.state$.asObservable();
  }

  selectStateSnapshot() {
    return this.state$.value;
  }

  private setState(state: Partial<InfoState>) {
    const newState: InfoState = { ...this.state$.value, ...state };

    this.state$.next(newState);
    localStorage.setItem(INFO_KEY, JSON.stringify(newState));
  }

}
